import {
  companyFvStaticBuyer as BuyerList,
  companyFvStaticSupplier as SupplierList,
} from '@/app/globalRedux/filter/companyFilter'
import { useTranslation } from '@/app/i18n/client'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'

const ActivitiesFilter = ({
  countList,
  selectedActivities,
  setValue,
  setAllSuppliers,
  setAllBuyers,
}: {
  countList: Record<string, number>[]
  selectedActivities: string[]
  setValue: (value: string) => any
  setAllSuppliers: () => any
  setAllBuyers: () => any
}) => {
  const { t } = useTranslation()
  const isAllSupplierSelected = SupplierList?.every((item) =>
    selectedActivities?.includes(item)
  )
  const isAllBuyersSelected = BuyerList?.every((item) =>
    selectedActivities?.includes(item)
  )

  const getCount = (key: string) => {
    const found = countList?.find((item) => item[key] !== undefined)
    return found ? found[key] : 0
  }

  return (
    <div
      className="shadow-[0_0_3px_0_rgba(0,0,0,0.06)] bg-neutral-50 border border-solid border-[#ebebeb] mt-[20px] rounded-[4px] mobile:mt-[10px]"
      suppressHydrationWarning
    >
      <div>
        <Accordion type="single" collapsible defaultValue="item-2">
          <AccordionItem value="item-2">
            <AccordionTrigger className="text-[18px] font-semibold text-[#222]">
              {t('Activities')}
            </AccordionTrigger>
            <AccordionContent className="!p-0 ">
              {/* {Suppliers} */}
              <Accordion
                type="single"
                collapsible
                className="!p-0"
                defaultValue="supplier"
              >
                <AccordionItem value="supplier" className="pb-[10px]">
                  <AccordionTrigger
                    className="text-[18px] font-semibold text-[#222] bg-[#eaeaea] mb-[10px]"
                    suppressHydrationWarning
                  >
                    <span
                      className=" flex flex-row   items-center w-[100%] gap-[10px]"
                      onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                      }}
                    >
                      <Checkbox
                        suppressHydrationWarning
                        className=" bg-[white]"
                        checked={isAllSupplierSelected}
                        onClick={() => {
                          setAllSuppliers()
                        }}
                      />
                      <p>{t('Suppliers')}</p>
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="px-[0px]">
                    <div className="flex flex-col  gap-[8px]">
                      {SupplierList?.map((supplier: string) => (
                        <div
                          className=" flex flex-row items-center gap-2  w-fit "
                          key={supplier}
                        >
                          <Checkbox
                            checked={selectedActivities.includes(supplier)}
                            id={supplier}
                            className="border-2 border-input"
                            onClick={() => {
                              setValue(supplier)
                            }}
                          />
                          <Label
                            htmlFor={supplier}
                            className="!cursor-pointer gap-[1px] text-sm  not-italic leading-[normal] tracking-[normal] text-left text-[#6f6f6f] flex flex-row"
                          >
                            {t(supplier)}
                            <span className=" ml-1 gap-[1px] flex flex-row">
                              ({getCount(supplier)})
                            </span>
                          </Label>
                        </div>
                      ))}
                    </div>
                  </AccordionContent>
                </AccordionItem>
              </Accordion>

              {/* {Buyers} */}
              <Accordion
                type="single"
                collapsible
                className="!p-0 "
                defaultValue="buyer"
              >
                <AccordionItem value="buyer">
                  <AccordionTrigger className="text-[18px] font-semibold text-[#222] bg-[#eaeaea] mb-[10px]">
                    <span
                      className=" flex flex-row   items-center w-[100%] gap-[10px]"
                      onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                      }}
                    >
                      <Checkbox
                        className=" bg-[white]"
                        checked={isAllBuyersSelected}
                        onClick={() => {
                          setAllBuyers()
                        }}
                      />
                      <p>{t('Buyers')}</p>
                    </span>
                  </AccordionTrigger>
                  <AccordionContent>
                    <div className="flex flex-col  gap-[8px]">
                      {BuyerList?.map((buyer: string) => (
                        <div
                          className="  flex flex-row items-center gap-2  w-fit "
                          key={buyer}
                        >
                          <Checkbox
                            checked={selectedActivities.includes(buyer)}
                            id={buyer}
                            onClick={() => {
                              setValue(buyer)
                            }}
                            className="border-2 border-input"
                          />
                          <Label
                            htmlFor={buyer}
                            className=" cursor-pointer  text-sm  not-italic leading-[normal] tracking-[normal] text-left text-[#6f6f6f] flex flex-row"
                          >
                            {t(buyer)}
                            <span className=" ml-1 gap-[1px] flex flex-row">
                              ({getCount(buyer)})
                            </span>
                          </Label>
                        </div>
                      ))}
                    </div>
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </div>
  )
}

export default ActivitiesFilter
